/* Copyright (c) 2022-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useUpdateResourceMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { generateActionSuccessText } from "~/tools";
import { useResource } from "../../ResourceProvider";
import { ResourceFields } from "./types";
import { getUpdateObject } from "./utils";

type Props = {
  onSuccess: () => void;
};

export function useUpdateResource({ onSuccess }: Props) {
  const { resource } = useResource();

  const [updateResourceMutation, { loading }] = useUpdateResourceMutation({
    onError: (error) => {
      showError(error.message);
    },
    onCompleted: () => {
      onSuccess();
      showSuccess(generateActionSuccessText("Resource")()("updated")());
    },
  });

  function updateResource(data: ResourceFields) {
    resource &&
      updateResourceMutation({
        variables: {
          input: {
            ...getUpdateObject(data, resource),
          },
        },
      });
  }

  return [updateResource, loading] as const;
}
